import _defaultTo from 'lodash/defaultTo';
import _get from 'lodash/get';
import _orderBy from 'lodash/orderBy';
// Serialization
import { deserialize, serialize } from 'serializr';
import { companySchema } from './schemas';

/**
* Serialization
*/
const serializerKey = 'company';

const deserializeCompany = (data) => deserialize(companySchema, data);

const serializeCompany = ({ name, parentId }) => ({
  [serializerKey]: {
    ...serialize(companySchema, {
      name: _defaultTo(name, null),
      ...(parentId && { parent_id: parentId }),
    }),
  },
});

/**
* Utils
*/
const sortCompanies = (companies, fields = ['name'], dirs = ['asc']) => (_orderBy(companies, fields, dirs));

const companyTitle = (companyData) => _get(companyData, 'name', '');

/**
* Model
*/
const company = {
  // Name and icon
  name: 'company',
  icon: 'company',

  // Serialization
  deserialize: deserializeCompany,
  serialize: serializeCompany,

  // Sort elements
  sortElements: sortCompanies,

  // Utils
  title: companyTitle,
};

module.exports = company;



// WEBPACK FOOTER //
// ./models/company.js